<p>stripe-payment works!</p>
